
// action types
export const SELECT_PHARMACY = "selectPharmacy";


// mutation types
export const SET_PHARMACY = "setPharmacy";


const state = {
  pharmacy: {}
};

const getters = {
  currentPharmacy(state) {
    return state.pharmacy;
  }
};

const actions = {
  [SELECT_PHARMACY](context, pharmacy) {
    context.commit(SET_PHARMACY, pharmacy);
  },
 
};

const mutations = {
  [SET_PHARMACY](state, pharmacy) {
    state.pharmacy = pharmacy;
  },
  
};

export default {
  state,
  actions,
  mutations,
  getters,
};
